module.exports = __webpack_public_path__ + "static/media/healthcare_bg.aa28bfc0.png";